@if (previewSceneId && !loadingPreview) {
  <div>
    <app-scene-preview [setSelectedSceneId]="previewSceneId"
      [setSceneWidth]="previewWidth"
      [setSceneHeight]="previewHeight"
      [previewWidth]="previewWidth"
      [autoScale]="true"
      [autoPlay]="true">
    </app-scene-preview>
  </div>
  <!-- <iframe [src]="previewUrl" height="150" width="240" title="Scene Animation Preview"></iframe> -->
}

@if (!previewSceneId || loadingPreview) {
  <div class="no-preview">
    <img src="./assets/images/empty_scene.png" width="{{previewWidth}}" height="{{previewHeight}}" style="object-fit: cover; opacity: 0.5;" />
      <button mat-raised-button type="button" color="primary" class="preview-button d-flex-center" (click)="previewAnimation();">
        <mat-icon>play_circle_outline</mat-icon>
        {{'general.preview' | transloco}}
      </button>    
  </div>
}
